import { Button } from "core/components/form-controls";
import TagList from "core/components/Tag";
import { useFormikCustom } from 'core/hooks/useFormikCustom';
import {
  getFieldTagProps,
} from 'core/utils/form';
import { _t } from "core/language";
import { useRecipe } from "./../../hooks/recipe";
import { useEffect } from "react";
import type { TFlavor } from "./../../store/types";
import ResetIcon from "../../assets/icon/reset.svg";

const FlavorList = ({flavors = []}: {flavors: TFlavor[]}) => {
  const { options, goToRecipeSuggession, resetRecipeOptions } = useRecipe()

  const formik = useFormikCustom({
    initialValues: {
      options: []
    },
    onSubmit(values, formikHelpers) {
      formikHelpers.setSubmitting(false);
      goToRecipeSuggession(values.options)
    },
  });

  useEffect(() => {
    formik.setValues({
      options,
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options])

  return (
    <form onSubmit={formik.onSubmit} className={'px-4 pt-[30px] relative'}>
      {formik.values.options?.length ? (
        <div className="absolute top-[20px] right-[18px]">
          <Button
            label={_t('ingredient.option.reset')}
            classBtn="font-medium px-[10px] py-[5.5px] text-[#111111] tracking-tighter"
            icon={ResetIcon}
            iconClassName="pr-[4px]"
            size="13px"
            onClickBtn={resetRecipeOptions}
          />
        </div>
      ): null}
      <div className="mb-[120px]">
      {flavors.map((flavor: TFlavor, key:number) => (
        <TagList
          key={flavor.id}
          label={flavor.name}
          options={flavor.flavor_items.map((item) => ({
            ...item, id: String(item.id)
          }))}
          className={`${key === 0 ? '' : 'mt-[30px]'}`}
          labelClassName="block mb-3.5 text-[16px] font-medium"
          activeClasses=" bg-primary hover:bg-primary !text-[#ffffff]"
          inactiveClasses="bg-white font-medium tracking-tighter ring-gray-300 ring-1 !text-[#333333]"
          {...getFieldTagProps(formik, 'options')}
        />
      ))}
      </div>
      {flavors.length ? (
        <div className="left-0 px-[16px] pb-[24px] fixed bottom-[60px] bg-white w-full">
          <div className="text-[11px] font-light">
            ※ {_t('ingredient.option.desc')}
          </div>
          <Button
            type="submit"
            label={_t('ingredient.option.complete')}
            classBtn="w-full mt-[14px] font-medium"
            primary={!!formik.values.options?.length}
            loading={formik.isSubmitting}
          />
        </div>
      ) : null}
    </form>
  )
}

export default FlavorList
